export enum MOTIV_TYPE_GROUP {
  UNSECURED = 'Unsecured',
  PURCHASE_AGREEMENT = 'PurchaseAgreement',
  OPTIONAL_PURCHASE_AGREEMENT = 'OptionalPurchaseAgreement',
  LEASE = 'Lease',
  BALLOON_PURCHASE_AGREEMENT = 'BalloonPurchaseAgreement',
}
